import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FullWidthContainer } from 'atoms/layout/FullWidthContainer';
import { Vertical } from 'atoms/layout/flex';
import { HeadlineS, LabelS } from 'atoms/typography';
import { Row } from 'components/seo/ui';
import { glossary } from 'lib/glossary';

import { RelatedPlayer, Props as RelatedPlayerProps } from './RelatedPlayer';

const StyledLabelS = styled(LabelS)`
  text-transform: uppercase;
`;

type Props<T extends string> = {
  stats: RelatedPlayerProps<T>['stats'];
  headers: Record<T, ReactNode>;
  players: RelatedPlayerProps<T>['player'][];
};

export const RelatedPlayers = <T extends string>({
  players,
  headers,
  stats,
}: Props<T>) => {
  return (
    <FullWidthContainer>
      <Vertical gap={1.5}>
        <HeadlineS as="h2">
          <FormattedMessage {...glossary.relatedPlayers} />
        </HeadlineS>
        <Vertical>
          <Row
            style={{
              gridTemplateColumns: `auto 1fr repeat(${stats.length}, calc(5 * var(--unit)))`,
            }}
          >
            <StyledLabelS as="p" color="var(--c-nd-600)" bold>
              <FormattedMessage {...glossary.name} />
            </StyledLabelS>
            <span />
            {stats.map(stat => (
              <LabelS as="p" key={stat} color="var(--c-nd-600)" bold>
                {headers[stat]}
              </LabelS>
            ))}
          </Row>
          {players.map(player => (
            <RelatedPlayer key={player.slug} player={player} stats={stats} />
          ))}
        </Vertical>
      </Vertical>
    </FullWidthContainer>
  );
};
